<!-- selectedBox -->
<div *ngIf="selectedBox.length == 0" class="required-quantity-box">
  <span class="quantity-font" style="color: #0c9aeb"> Recommended Package </span>
  <div class="section-title" *ngFor="let item of getUniqueBoxes(recomendedBox)">
    <span>{{ item.box.name }}</span>
    <span class="badge count">{{ item.count }}</span>
  </div>
</div>
<!-- selectedBox -->
<div *ngIf="selectedBox.length > 0" class="selected-quantity-box">
  <span class="quantity-font" style="color: #12b769"> Selected Package </span>

  <div class="section-title" *ngFor="let item of getUniqueBoxes(selectedBox)">
    <span>{{ item.box.name }}</span>
    <span class="badge count">{{ item.count }}</span>
  </div>
</div>

<!-- oofcanvas for selecting selectedBox  -->
<div
  class="offcanvas offcanvas-bottom box-suggestion-offcanvas"
  tabindex="-1"
  id="offcanvasBottom"
  aria-labelledby="offcanvasBottomLabel"
>
<!-- header -->
  <div class="offcanvas-header p-0">
    <h5 class="offcanvas-title lg-header-text" id="offcanvasBottomLabel">Select Packaging Type</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
      (click)="cancelBoxSelection()"
    ></button>
  </div>

  <div class="offcanvas-body p-0 small" style="padding: 0">
    <!-- recomendedBox body -->
    <div class="box-card" *ngFor="let item of getUniqueBoxes(recomendedBox)">
      <div class="box-header">
        <span class="recommended">Recommended</span>
      </div>
      <div class="box-body">
        <h3 class="md-header-text m-0">{{ item.box.name }}</h3>
        <p class="box-desc">{{ item.box.description }}</p>

        <div class="box-details">
          <div class="detail">
            <span class="label">Max Weight</span>
            <span class="sm-header-text"
              >{{ item.box.maxWeight }} {{ weightUnits[item.box.weightUnit] }}</span
            >
          </div>
          <div class="detail">
            <span class="label">Size</span>
            <span class="sm-header-text"
              >{{ item.box.height }} × {{ item.box.width }} × {{ item.box.length }}
              {{ dimensionUnits[item.box.dimensionUnit] }}</span
            >
          </div>
        </div>

        <div class="box-tags" *ngIf="item.box.customCategory && item.box.customCategory.length > 0">
          <span class="tag" *ngFor="let atr of item.box.customCategory">{{ atr }}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center mt-1">
          <span class="sm-header-text">Package Quantity</span>
          <div class="d-flex justify-content-between gap-3">
            <button class="qty-btn" (click)="decreaseQuantity(item.box)">−</button>
            <span class="qty-value">{{ item.count }}</span>
            <button class="qty-btn" (click)="increaseQuantity(item.box)">+</button>
          </div>
        </div>
      </div>
    </div>
    <!-- allbox body -->
    <h5 class="offcanvas-title lg-header-text mt-3" id="offcanvasBottomLabel">
      Other packaging options
    </h5>
    <div *ngIf="allBox.length === 0" class="no-options-message">
      No other packaging options available
    </div>
    <div
      class="box-card"
      [ngClass]="isSelected(box) ? 'selected' : 'unselected'"
      *ngFor="let box of allBox"
    >
      <div class="box-header" (click)="toggleSelection(box)">
        <span
          class="recommended"
          [ngClass]="isSelected(box) ? 'recommended-selected' : 'recommended-unselected'"
          >Selected</span
        >
      </div>
      <div class="box-body" (click)="toggleSelection(box)">
        <h3 class="md-header-text m-0">{{ box.name }}</h3>
        <p class="box-desc">{{ box.description }}</p>

        <div class="box-details">
          <div class="detail">
            <span class="label">Max Weight</span>
            <span class="sm-header-text"
              >{{ box.maxWeight }} {{ weightUnits[box.weightUnit] }}</span
            >
          </div>
          <div class="detail">
            <span class="label">Size</span>
            <span class="sm-header-text"
              >{{ box.height }} × {{ box.width }} × {{ box.length }}
              {{ dimensionUnits[box.dimensionUnit] }}</span
            >
          </div>
        </div>

        <div class="box-tags" *ngIf="box.customCategory && box.customCategory.length > 0">
          <span class="tag" *ngFor="let atr of box.customCategory">{{ atr }}</span>
        </div>
      </div>
      <div *ngIf="isSelected(box)" class="d-flex justify-content-between align-items-center mt-1">
        <span class="sm-header-text">Package Quantity</span>
        <div class="d-flex justify-content-between gap-3">
          <button class="qty-btn" (click)="decreaseQuantity(box)">−</button>
          <span class="qty-value">{{ getSelectBoxQuantity(box) }}</span>
          <button class="qty-btn" (click)="increaseQuantity(box)">+</button>
        </div>
      </div>
    </div>
  </div>

  <div class="offcanvas-bottom small">
    <button
      class="black-btn custom-btn w-100"
      [ngClass]="selectedBox && selectedBox.length === 0 ? 'btn-disabled' : 'btn-enabled'"
      [disabled]="!selectedBox || selectedBox.length === 0"
      (click)="onConfirm()"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    >
      Confirm
    </button>
  </div>
</div>